import Clarity from "@microsoft/clarity";

// Your Clarity project ID
const CLARITY_PROJECT_ID = "t627k7rcif";

// Prevent duplicate calls and excessive logging
let isInitialized = false;
let lastIdentifiedUser = null;
const isDevelopment = process.env.NODE_ENV === "development";

// Initialize Clarity (only once)
export const initializeClarity = () => {
  if (isInitialized) return;

  try {
    Clarity.init(CLARITY_PROJECT_ID);
    isInitialized = true;
    if (isDevelopment) console.log("Microsoft Clarity initialized");
  } catch (error) {
    console.error("Failed to initialize Microsoft Clarity:", error);
  }
};

// Identify API - Call this when you have user information (prevent duplicates)
export const identifyUser = (
  customId,
  customSessionId = null,
  customPageId = null,
  friendlyName = null
) => {
  // Prevent duplicate identification calls for the same user
  if (lastIdentifiedUser === customId) return;

  try {
    Clarity.identify(customId, customSessionId, customPageId, friendlyName);
    lastIdentifiedUser = customId;
    // Remove excessive logging
  } catch (error) {
    console.error("Failed to identify user in Clarity:", error);
  }
};

// Custom tags API - Use this to add arbitrary tags to sessions (lightweight)
export const setTag = (key, value) => {
  try {
    Clarity.setTag(key, value);
    // Remove console.log to reduce noise
  } catch (error) {
    if (isDevelopment) console.error("Failed to set Clarity tag:", error);
  }
};

// Custom events API - Track specific events (lightweight)
export const trackEvent = (eventName) => {
  try {
    Clarity.event(eventName);
    // Remove console.log to reduce noise
  } catch (error) {
    if (isDevelopment) console.error("Failed to track Clarity event:", error);
  }
};

// Cookie consent - Call this if you need to handle cookie consent
export const setCookieConsent = (consent = true) => {
  try {
    Clarity.consent(consent);
  } catch (error) {
    if (isDevelopment)
      console.error("Failed to set Clarity cookie consent:", error);
  }
};

// Upgrade session API - Prioritize specific sessions for recording (use sparingly)
export const upgradeSession = (reason) => {
  try {
    Clarity.upgrade(reason);
  } catch (error) {
    if (isDevelopment)
      console.error("Failed to upgrade Clarity session:", error);
  }
};
